var _a, _b, _c;
import { EActionState, createCustomAction } from "../utils/action.utils";
import { GENERATOR_PARAMS } from "./preference.constants";
var EActionCustom;
(function (EActionCustom) {
    EActionCustom["GetPreference"] = "GET_PREFERENCE";
    EActionCustom["CreatePreference"] = "CREATE_PREFERENCE";
    EActionCustom["UpdatePreference"] = "UPDATE_PREFERENCE";
})(EActionCustom || (EActionCustom = {}));
var generateGetPreferenceActions = function () { return ({
    getPreferencesStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetPreference,
        state: EActionState.Start,
    }),
    getPreferenceSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetPreference,
        state: EActionState.Success,
    }),
    getPreferenceFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetPreference,
        state: EActionState.Fail,
    }),
}); };
var generateCreatePreferenceActions = function () { return ({
    createPreferenceStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.CreatePreference,
        state: EActionState.Start,
    }),
    createPreferenceSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.CreatePreference,
        state: EActionState.Success,
    }),
    createPreferenceFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.CreatePreference,
        state: EActionState.Fail,
    }),
}); };
var generateUpdatePreferenceActions = function () { return ({
    updatePreferenceStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UpdatePreference,
        state: EActionState.Start,
    }),
    updatePreferenceSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UpdatePreference,
        state: EActionState.Success,
    }),
    updatePreferenceFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UpdatePreference,
        state: EActionState.Fail,
    }),
}); };
export var getPreferencesStart = (_a = generateGetPreferenceActions(), _a.getPreferencesStart), getPreferenceSucceeded = _a.getPreferenceSucceeded, getPreferenceFailed = _a.getPreferenceFailed;
export var createPreferenceStart = (_b = generateCreatePreferenceActions(), _b.createPreferenceStart), createPreferenceSucceeded = _b.createPreferenceSucceeded, createPreferenceFailed = _b.createPreferenceFailed;
export var updatePreferenceStart = (_c = generateUpdatePreferenceActions(), _c.updatePreferenceStart), updatePreferenceSucceeded = _c.updatePreferenceSucceeded, updatePreferenceFailed = _c.updatePreferenceFailed;
